import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { APP_CONFIG } from './app/appconfig/appconfig';
import { CLIENT_CONFIG } from './app/appconfig/client-config';
import { ACCESS_MGMT_PRELOADED_CONFIG } from '@stantec/access-mgmt';

Promise.all([
  fetch('api/ClientEnvironment', { cache: 'no-store' }).then((response) =>
    response.json(),
  ),
  fetch('api/clientconfig', { cache: 'no-store' }).then((response) =>
    response.json(),
  ),
])
  .then(([environmentConfig, clientConfig]) => {
    // Bootstrap the Angular application with the combined configuration
    platformBrowserDynamic([
      { provide: APP_CONFIG, useValue: environmentConfig },
      { provide: CLIENT_CONFIG, useValue: clientConfig },
      { provide: ACCESS_MGMT_PRELOADED_CONFIG, useValue: clientConfig },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((error) => console.error('Fetch error:', error));
